import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6c89929c = () => interopDefault(import('../../../pages/myhausheld/analysis/index.vue' /* webpackChunkName: "pages/myhausheld/analysis/index" */))
const _03bbaff4 = () => interopDefault(import('../../../pages/myhausheld/appointments/index.vue' /* webpackChunkName: "pages/myhausheld/appointments/index" */))
const _69d71e38 = () => interopDefault(import('../../../pages/myhausheld/conditions/index.vue' /* webpackChunkName: "pages/myhausheld/conditions/index" */))
const _399f8ef9 = () => interopDefault(import('../../../pages/myhausheld/craftsmen/index.vue' /* webpackChunkName: "pages/myhausheld/craftsmen/index" */))
const _16867cac = () => interopDefault(import('../../../pages/myhausheld/dashboard/index.vue' /* webpackChunkName: "pages/myhausheld/dashboard/index" */))
const _4f69fd63 = () => interopDefault(import('../../../pages/myhausheld/dataProtection/index.vue' /* webpackChunkName: "pages/myhausheld/dataProtection/index" */))
const _561c2925 = () => interopDefault(import('../../../pages/myhausheld/index.vue' /* webpackChunkName: "pages/myhausheld/index" */))
const _8a093066 = () => interopDefault(import('../../../pages/myhausheld/impressum/index.vue' /* webpackChunkName: "pages/myhausheld/impressum/index" */))
const _1fc3cc3c = () => interopDefault(import('../../../pages/myhausheld/login.vue' /* webpackChunkName: "pages/myhausheld/login" */))
const _3a3d3748 = () => interopDefault(import('../../../pages/myhausheld/mortgage/index.vue' /* webpackChunkName: "pages/myhausheld/mortgage/index" */))
const _483f6582 = () => interopDefault(import('../../../pages/myhausheld/profile/index.vue' /* webpackChunkName: "pages/myhausheld/profile/index" */))
const _c5c2ea8c = () => interopDefault(import('../../../pages/myhausheld/projects/index.vue' /* webpackChunkName: "pages/myhausheld/projects/index" */))
const _5844d41e = () => interopDefault(import('../../../pages/myhausheld/real-estate/index.vue' /* webpackChunkName: "pages/myhausheld/real-estate/index" */))
const _0c70d243 = () => interopDefault(import('../../../pages/myhausheld/todos/index.vue' /* webpackChunkName: "pages/myhausheld/todos/index" */))
const _34fd29b1 = () => interopDefault(import('../../../pages/myhausheld/tools/index.vue' /* webpackChunkName: "pages/myhausheld/tools/index" */))
const _4c5d0ba2 = () => interopDefault(import('../../../pages/myhausheld/analysis/create.vue' /* webpackChunkName: "pages/myhausheld/analysis/create" */))
const _cdb509ca = () => interopDefault(import('../../../pages/myhausheld/auth/forgot-password.vue' /* webpackChunkName: "pages/myhausheld/auth/forgot-password" */))
const _35a6b87d = () => interopDefault(import('../../../pages/myhausheld/auth/register.vue' /* webpackChunkName: "pages/myhausheld/auth/register" */))
const _490dbae8 = () => interopDefault(import('../../../pages/myhausheld/mortgage/realEstateReview.vue' /* webpackChunkName: "pages/myhausheld/mortgage/realEstateReview" */))
const _2e671744 = () => interopDefault(import('../../../pages/myhausheld/projects/create.vue' /* webpackChunkName: "pages/myhausheld/projects/create" */))
const _4f7247b6 = () => interopDefault(import('../../../pages/myhausheld/tools/appointments.vue' /* webpackChunkName: "pages/myhausheld/tools/appointments" */))
const _4a4e0e46 = () => interopDefault(import('../../../pages/myhausheld/profile/settings.vue' /* webpackChunkName: "pages/myhausheld/profile/settings" */))
const _13ff8d92 = () => interopDefault(import('../../../pages/myhausheld/tools/counselor.vue' /* webpackChunkName: "pages/myhausheld/tools/counselor" */))
const _2f1df382 = () => interopDefault(import('../../../pages/myhausheld/tools/craftsmen.vue' /* webpackChunkName: "pages/myhausheld/tools/craftsmen" */))
const _1338f517 = () => interopDefault(import('../../../pages/myhausheld/tools/documents.vue' /* webpackChunkName: "pages/myhausheld/tools/documents" */))
const _4c72520e = () => interopDefault(import('../../../pages/myhausheld/tools/finance.vue' /* webpackChunkName: "pages/myhausheld/tools/finance" */))
const _b44e2e68 = () => interopDefault(import('../../../pages/myhausheld/tools/invoice.vue' /* webpackChunkName: "pages/myhausheld/tools/invoice" */))
const _b8628bb8 = () => interopDefault(import('../../../pages/myhausheld/analysis/_component.vue' /* webpackChunkName: "pages/myhausheld/analysis/_component" */))
const _c40d1652 = () => interopDefault(import('../../../pages/myhausheld/auth/new-password/_token.vue' /* webpackChunkName: "pages/myhausheld/auth/new-password/_token" */))
const _10806168 = () => interopDefault(import('../../../pages/myhausheld/auth/password-reset/_passwordResetMailSent.vue' /* webpackChunkName: "pages/myhausheld/auth/password-reset/_passwordResetMailSent" */))
const _272a9088 = () => interopDefault(import('../../../pages/myhausheld/real-estate/_realEstate.vue' /* webpackChunkName: "pages/myhausheld/real-estate/_realEstate" */))
const _915fc5bc = () => interopDefault(import('../../../pages/myhausheld/projects/_project.vue' /* webpackChunkName: "pages/myhausheld/projects/_project" */))
const _44deffab = () => interopDefault(import('../../../pages/myhausheld/welcome/_craft.vue' /* webpackChunkName: "pages/myhausheld/welcome/_craft" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/analysis",
    component: _6c89929c,
    name: "analysis"
  }, {
    path: "/appointments",
    component: _03bbaff4,
    name: "appointments"
  }, {
    path: "/conditions",
    component: _69d71e38,
    name: "conditions"
  }, {
    path: "/craftsmen",
    component: _399f8ef9,
    name: "craftsmen"
  }, {
    path: "/dashboard",
    component: _16867cac,
    name: "dashboard"
  }, {
    path: "/dataProtection",
    component: _4f69fd63,
    name: "dataProtection"
  }, {
    path: "/de",
    component: _561c2925,
    name: "index___de"
  }, {
    path: "/impressum",
    component: _8a093066,
    name: "impressum"
  }, {
    path: "/login",
    component: _1fc3cc3c,
    name: "login"
  }, {
    path: "/mortgage",
    component: _3a3d3748,
    name: "mortgage"
  }, {
    path: "/profile",
    component: _483f6582,
    name: "profile"
  }, {
    path: "/projects",
    component: _c5c2ea8c,
    name: "projects"
  }, {
    path: "/real-estate",
    component: _5844d41e,
    name: "real-estate"
  }, {
    path: "/todos",
    component: _0c70d243,
    name: "todos"
  }, {
    path: "/tools",
    component: _34fd29b1,
    name: "tools"
  }, {
    path: "/analysis/create",
    component: _4c5d0ba2,
    name: "analysis-create"
  }, {
    path: "/auth/forgot-password",
    component: _cdb509ca,
    name: "auth-forgot-password"
  }, {
    path: "/auth/register",
    component: _35a6b87d,
    name: "auth-register"
  }, {
    path: "/de/allgemeine-geschaeftsbedingungen",
    component: _69d71e38,
    name: "conditions___de"
  }, {
    path: "/de/analyse",
    component: _6c89929c,
    name: "analysis___de"
  }, {
    path: "/de/anmelden",
    component: _1fc3cc3c,
    name: "login___de"
  }, {
    path: "/de/dashboard",
    component: _16867cac,
    name: "dashboard___de"
  }, {
    path: "/de/datenschutz",
    component: _4f69fd63,
    name: "dataProtection___de"
  }, {
    path: "/de/handwerker",
    component: _399f8ef9,
    name: "craftsmen___de"
  }, {
    path: "/de/immobilie",
    component: _5844d41e,
    name: "real-estate___de"
  }, {
    path: "/de/immobilie-erfassen",
    component: _4c5d0ba2,
    name: "analysis-create___de"
  }, {
    path: "/de/immobilien-bewertung",
    component: _490dbae8,
    name: "mortgage-realEstateReview___de"
  }, {
    path: "/de/impressum",
    component: _8a093066,
    name: "impressum___de"
  }, {
    path: "/de/meine-finanzen",
    component: _3a3d3748,
    name: "mortgage___de"
  }, {
    path: "/de/passwort-vergessen",
    component: _cdb509ca,
    name: "auth-forgot-password___de"
  }, {
    path: "/de/profil",
    component: _483f6582,
    name: "profile___de"
  }, {
    path: "/de/registration",
    component: _35a6b87d,
    name: "auth-register___de"
  }, {
    path: "/de/renovation-erstellen",
    component: _2e671744,
    name: "projects-create___de"
  }, {
    path: "/de/renovationen",
    component: _c5c2ea8c,
    name: "projects___de"
  }, {
    path: "/de/termine",
    component: _03bbaff4,
    name: "appointments___de"
  }, {
    path: "/de/termine",
    component: _4f7247b6,
    name: "tools-appointments___de"
  }, {
    path: "/de/to-dos",
    component: _0c70d243,
    name: "todos___de"
  }, {
    path: "/de/tools",
    component: _34fd29b1,
    name: "tools___de"
  }, {
    path: "/mortgage/realEstateReview",
    component: _490dbae8,
    name: "mortgage-realEstateReview"
  }, {
    path: "/profile/settings",
    component: _4a4e0e46,
    name: "profile-settings"
  }, {
    path: "/projects/create",
    component: _2e671744,
    name: "projects-create"
  }, {
    path: "/tools/appointments",
    component: _4f7247b6,
    name: "tools-appointments"
  }, {
    path: "/tools/counselor",
    component: _13ff8d92,
    name: "tools-counselor"
  }, {
    path: "/tools/craftsmen",
    component: _2f1df382,
    name: "tools-craftsmen"
  }, {
    path: "/tools/documents",
    component: _1338f517,
    name: "tools-documents"
  }, {
    path: "/tools/finance",
    component: _4c72520e,
    name: "tools-finance"
  }, {
    path: "/tools/invoice",
    component: _b44e2e68,
    name: "tools-invoice"
  }, {
    path: "/de/profil/einstellungen",
    component: _4a4e0e46,
    name: "profile-settings___de"
  }, {
    path: "/de/tools/finanzen",
    component: _4c72520e,
    name: "tools-finance___de"
  }, {
    path: "/de/tools/handwerker",
    component: _2f1df382,
    name: "tools-craftsmen___de"
  }, {
    path: "/de/tools/meine-rechnungen",
    component: _b44e2e68,
    name: "tools-invoice___de"
  }, {
    path: "/de/tools/meine-unterlagen",
    component: _1338f517,
    name: "tools-documents___de"
  }, {
    path: "/de/tools/ratgeber",
    component: _13ff8d92,
    name: "tools-counselor___de"
  }, {
    path: "/de/analyse/komponente/:component?",
    component: _b8628bb8,
    name: "analysis-component___de"
  }, {
    path: "/auth/new-password/:token?",
    component: _c40d1652,
    name: "auth-new-password-token"
  }, {
    path: "/auth/password-reset/:passwordResetMailSent?",
    component: _10806168,
    name: "auth-password-reset-passwordResetMailSent"
  }, {
    path: "/de/immobilie/:realEstate?",
    component: _272a9088,
    name: "real-estate-realEstate___de"
  }, {
    path: "/de/neues-passwort/:token?",
    component: _c40d1652,
    name: "auth-new-password-token___de"
  }, {
    path: "/de/passwort-zuruecksetzen/:passwordResetMailSent?",
    component: _10806168,
    name: "auth-password-reset-passwordResetMailSent___de"
  }, {
    path: "/de/renovation/:project?",
    component: _915fc5bc,
    name: "projects-project___de"
  }, {
    path: "/de/willkommen/:craft?",
    component: _44deffab,
    name: "welcome-craft___de"
  }, {
    path: "/analysis/:component",
    component: _b8628bb8,
    name: "analysis-component"
  }, {
    path: "/projects/:project",
    component: _915fc5bc,
    name: "projects-project"
  }, {
    path: "/real-estate/:realEstate?",
    component: _272a9088,
    name: "real-estate-realEstate"
  }, {
    path: "/welcome/:craft?",
    component: _44deffab,
    name: "welcome-craft"
  }, {
    path: "/",
    component: _561c2925,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
